module.exports = __webpack_public_path__ + "static/assets/f420704fe490ab022261f449282df1ee.gif";